<h1 mat-dialog-title>{{ 'executionEdit.dialog.confirmSave.title' | translate }}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="thermal-theme">

    @if (data.showReason) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'executionEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="data.reason" formControlName="reason" [errorStateMatcher]="matcher" required
        [ngModelOptions]="{standalone: true}"></textarea>
        <mat-error>
          {{ 'executionEdit.dialog.confirmSave.reason.error' | translate }}
        </mat-error>
      </mat-form-field>
    }

  </div>
  <div mat-dialog-actions class="thermal-theme">
    <div fxFlex></div>

    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>